export default "__VITE_ASSET__Dpm7uR2q__"